import React, { SVGProps } from 'react'
const SvgAlertCircledFilled = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h24v24H0z" />
      <path
        fill={props.fill || '#EB505B'}
        d="M12 2.25c5.385 0 9.75 4.365 9.75 9.75s-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12 6.615 2.25 12 2.25Z"
      />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M11.898 6.26a.75.75 0 0 1 .742.64l.008.11v7.175a.75.75 0 0 1-1.492.11l-.008-.11V7.01a.75.75 0 0 1 .75-.75ZM11.872 16.252a.75.75 0 0 1 .742.64l.008.11v.423a.75.75 0 0 1-1.492.11l-.008-.11v-.423a.75.75 0 0 1 .75-.75Z"
      />
    </g>
  </svg>
)
export default SvgAlertCircledFilled
